import tripEvents from './../../config/events.constant';
import CANCEL_ITEM_STATUSES from './../../config/cancel-item-statuses';
import {STAGE} from './../../services/trip-details-service';
import suppliers from './../../../../modules/supplier/suppliers';

export default function TripDetailsController(
    $scope,
    $rootScope,
    $state,
    $window,
    scrollService,
    TRIP_CAN_BE_BOOK_STATUSES,
    TRIP_CONSTANTS,
    tripId,
    tripDetails,
    tripDetailsService,
    tripCancellationService,
    isVisibleSendBlock,
    isVisibleVerifyBlock,
    tripFactory,
    userService,
    l10nService,
    tripDepartmentId,
    tripAPI,
    flightsUtils,
    modalService,
    ktAlert,
    ReviewConstructor,
    tripUtils,
    tripItemService,
    tripTravellerAllocationService,
) {
    'ngInject';

            const vm = this;
            const STATUS_CONFIRMED = 'Confirmed';
            const STATUS_CANCELLED = 'Cancelled';
            const STATUS_HELD = 'Held';
            const STATUS_PAST = 'Past';
            const STATUS_QUOTE = 'Quote';
            const STATUS_ENROUTE = 'Enroute';
            $scope.tripDetails = tripDetails;
            $scope.seats = {};

            const cancellation = {
                cancellationMsg: {},
                cancellationItemMsg: {},
            };

            Object.assign(vm, {
                $onInit,
                resendConfirmation,
                isTripConfirmed,
                isRequestConfirmationButtonVisible,
                isCancelTripBtnDisabled,
                toggleReviewBlockForBooker,
                toggleAddToCalendar,
                isAddToCalendarVisible,
                isResendConfirmationVisible,
                doesTripContainMultipleTrainlineItems: () => tripDetailsService.doesTripContainMultipleTrainlineItems($scope.tripDetails),
                isBookHoldViewCostsButtonVisible,
                cancellation,
                getTitle: () => tripDetailsService.getTitle($scope.tripDetails),
                bookAmendment: () => tripDetailsService.bookAmendment($scope.tripDetails),
                isAmendmentApproved: () => tripDetailsService.isAmendmentApproved($scope.tripDetails),
                isWarningPanelVisible,
                isResendConfirmationEnabled,
                isVerifyIconEnabled,
                isShareTripBtnEnabled,
                closeRequestSentAlert,
                isBookingComCancellationMessageVisible,
                l10nService,
                isAddToCalendarToggled: false,
            });

            function isBookHoldViewCostsButtonVisible() {
                return !$scope.tripDetails.IsAwaitingUserApproval
                    && (userService.isBooker() || userService.isTripHolder())
                    && !showAcceptDismiss();
            }

            function toggleAddToCalendar() {
                vm.isAddToCalendarToggled = !vm.isAddToCalendarToggled;
            }

            function isAddToCalendarVisible() {
                return vm.isTripConfirmed()
                    && !$rootScope.readOnlyMode
                    && !$scope.tripDetails.IsOfflineTrip;
            }

            function isResendConfirmationVisible() {
                return !$scope.tripDetails.Locked
                    && !$rootScope.readOnlyMode;
            }

            function closeRequestSentAlert() {
                $scope.tripDetails._changeRequestSent = false;
            }

            function isTripConfirmed() {
                return $scope.tripDetails
                    && $scope.tripDetails.Status === STATUS_CONFIRMED;
            }

            function isResendConfirmationEnabled() {
               return !!($scope.tripDetails
                   && $scope.tripDetails.PnrLocators
                   && $scope.tripDetails.PnrLocators.length !== 0);
            }

            function isVerifyIconEnabled() {
                return !($scope.tripDetails
                    && $scope.tripDetails.IsOfflineTrip
                    || $scope.tripDetails.Locked
                    || $scope.isTripCancelled
                    || $scope.tripDetails.Status === 'Confirmed');
            }

            function resendConfirmation() {
                if ($rootScope.readOnlyMode) {
                    $state.go('login');
                }
                tripAPI.resendConfirmation(tripDetails.Id)
                    .then(() => {
                        const translation = l10nService.localize('Email successfully resent');
                        $window.alert(translation);
                    });
            }
            function isShareTripBtnEnabled() {
                return !($scope.tripDetails
                    && $scope.tripDetails.Locked
                    || $scope.isTripCancelled);
            }

            function isCancelTripBtnDisabled() {
                return $scope.tripDetails.Locked
                    || $scope.tripDetails.IsOfflineTrip
                    || $scope.isTripCancelled
                    || $scope.tripCannotBeCancelled();
            }

            function isLockedOrCancelled() {
                return $scope.tripDetails.Locked
                    || $scope.isTripCancelled;
            }

            function isLockedCancelledOrConfirmed() {
                return isLockedOrCancelled() || tripDetails.Status === STATUS_CONFIRMED;
            }

            function isBookingComCancellationMessageVisible() {
                return doesAtleastOneBookingComProductExist()
                    && $scope.tripDetails.Status === STATUS_CONFIRMED;
            }

            function doesAtleastOneBookingComProductExist() {
                return $scope.tripDetails
                    && $scope.tripDetails.Hotels
                    && $scope.tripDetails.Hotels.some(({Supplier, Status}) => {
                        return Supplier === suppliers.bookingCom.id
                            && Status !== STATUS_CANCELLED;
                    });
            }


            function $onInit() {
                $scope.$on(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS_FINISHED, initializeSelectedSeats);
                initializeSelectedSeats();

                $scope.$on(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS, function() {
                    tripFactory.tripDetails(tripId)
                        .then(({Flights}) => {
                            $scope.tripDetails.Flights = Flights;
                            $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS_FINISHED);
                        });
                });

                $scope.validationError = false;
                if ($scope.tripDetails.ApprovalSettings) {
                    $scope.itSelfApprover = $scope.tripDetails.ApprovalSettings.ItselfApprovingTrip;
                }
                $scope.standardUser = $rootScope.isStandardUser;
                $scope.isUserHaveRules = userService.isCheckoutAllowed();
                $scope.isReviewer = tripDetails.ReviewTripInfo.CanBeAccepted || tripDetails.ReviewTripInfo.CanBeCommented;
                $scope.showAcceptDismiss = showAcceptDismiss;
                $scope.canBeAccepted = tripDetails.ReviewTripInfo.CanBeAccepted;
                $scope.isTripCancelled = tripDetailsService.isTripCancelled(tripDetails);

                $scope.atLeastOneReviewWasSent = tripDetails.ReviewTripInfo
                    && tripDetails.ReviewTripInfo.FeedbackReviews
                    && tripDetails.ReviewTripInfo.FeedbackReviews.length;

                $scope.sendButtonTitle = $scope.atLeastOneReviewWasSent ? 'Resend' : 'Send';

                $scope.showCancelledTooltip = function(item) {
                    return !item.CanBeCancelled;
                };

                $scope.itemCannotBeCancelled = tripItemService.itemCannotBeCancelled;

                $scope.approveTrip = function(action) {
                    $scope.$broadcast(tripEvents.TRIP_SUBMIT_APPROVAL_FORM, action);
                };

                $scope.readOnlyMode = $rootScope.readOnlyMode;
                $rootScope.$broadcast('readOnlyModeToggle', $scope.readOnlyMode);

                $scope.canBookOrHold = function() {
                    return !$scope.readOnlyMode
                        && !$scope.validation.visible
                        && !$scope.validation.messages.warnings
                        && $scope.isUserHaveRules
                        && $scope.tripDetails.IsCheckOutAllowed;
                };

                $scope.wasConfirmed = $scope.tripDetails.WasConfirmed;

                $scope.bookAttrTitle = function() {
                    if (!$scope.isUserHaveRules) {
                        return l10nService.localize('There may be rules for your department that prevent'
                            + ' this itinerary being booked, please re-create it to verify');
                    }

                    return tripFactory.getBookErrorTooltipContent(
                        $scope.tripDetails.CanBeBookedStatus,
                        userService.isUSRegion()
                    );
                };

                $scope.reviewCommentRequired = false;
                $scope.reviewCommentMessage = (tripDetails.ReviewTripInfo.CanBeAccepted)
                    ? l10nService.localize('Please review your travel options below and provide your feedback to the booker by either accepting or rejecting at least one preferred option, and/or using the comments box to provide additional information or advise the booker if no options are satisfactory. Click ‘Reviewed’ once you’re done')
                    : l10nService.localize('Please review your travel options below and provide your feedback to the booker by using the comments box. Click ‘Reviewed’ once you’re done.');

                $scope.reviewSuccess = {show: false, message: ''};
                $scope.reviewSuccess.message = (tripDetails.ReviewTripInfo.CanBeAccepted)
                    ? l10nService.localize('Thank you for your response,') + ' ' + $scope.tripDetails.ReviewTripInfo.RequesterName + ' ' + l10nService.localize('will be notified')
                    : l10nService.localize('Thank you for your response,') + ' ' + $scope.tripDetails.ReviewTripInfo.RequesterName + ' ' + l10nService.localize('will be notified once all reviewers have responded');

                $scope.reviewComment = {message: ''};
                $scope.reviewTrip = function() {
                    const infoModal = modalService.createInfoModal(l10nService.localize('Reviewed successfully'), $scope.reviewSuccess.message);

                    const isRequired = tripFactory.checkReviewRequirement(tripDetails.reviewModel);

                    if (isRequired && !$scope.reviewComment.message) {
                        $scope.reviewCommentRequired = true;
                        $scope.validationError = true;
                        return;
                    }

                    $scope.validationError = false;
                    tripFactory.generateReviewRequest(tripDetails, $scope.reviewComment.message, tripId)
                        .then(infoModal)
                        .then(afterReviewSentSuccess);

                    function afterReviewSentSuccess() {
                        $state.reload($state.current.name);
                    }
                };

                $scope.isVisibleSendBlock = isVisibleSendBlock;
                $scope.toggleSendBlock = function() {
                    if (isLockedOrCancelled()) {
                        return;
                    }

                    if ($rootScope.readOnlyMode) {
                        $state.go('login');
                    }

                    $scope.isVisibleSendBlock = !$scope.isVisibleSendBlock;
                    $scope.isVisibleReviewBlock = false;
                    $scope.showChangesBlock = false;
                };

                $scope.isVisibleReviewBlock = isVisibleReviewBlockInitially();

                $scope.toggleReviewBlock = function() {
                    if ($rootScope.readOnlyMode) {
                        $state.go('login');
                    }

                    $scope.isVisibleReviewBlock = !$scope.isVisibleReviewBlock;
                    $scope.showChangesBlock = false;
                    $scope.isVisibleSendBlock = false;
                };

                $scope.showChangesBlock = false;
                $scope.toggleChangeBlock = function() {
                    if ($rootScope.readOnlyMode) {
                        $state.go('login');
                        return null;
                    }

                    $scope.isVisibleReviewBlock = false;
                    $scope.isVisibleSendBlock = false;
                    $scope.showChangesBlock = !$scope.showChangesBlock;
                };

                $scope.showTravelersBlock = !_.isEmpty($scope.tripDetails.Travelers);

                $scope.tripCannotBeCancelled = function() {
                    return $scope.tripDetails.CanBeCancelled === false;
                };

                const validation = {
                    visible: false,
                    messages: {
                        errors: [],
                        payment: {
                            isValid: false,
                            methods: [],
                        },
                        warnings: false,
                    },
                };
                $scope.validation = angular.copy(validation);

                $scope.bookTrip = function() {
                    if ($rootScope.readOnlyMode) {
                        $state.go('login');

                        return null;
                    }

                    if (tripDetails.Status === STATUS_CONFIRMED || tripDetails.Status === STATUS_PAST) {
                        const validStatus = {
                            isValid: true,
                        };
                        tripFactory.showCheckout(tripId, tripDepartmentId, validStatus, false);
                        return false;
                    }

                    $rootScope.isLoading = true;

                    const _tripId = tripFactory.isHash(tripId) ? tripDetails.Id : tripId;

                    tripFactory.validateTrip(_tripId, $scope.tripDetails).then((validStatus) => {
                            $scope.temporaryTripId = tripId;
                            if (validStatus.isValid && !validStatus.warning.length) {
                                tripFactory.showCheckout(_tripId, tripDepartmentId, validStatus, false);
                            } else {
                                $scope.validation = {
                                    visible: true,
                                    messages: {
                                        errors: validStatus.errors,
                                        payment: {
                                            isValid: validStatus.paymentsValid,
                                            methods: validStatus.paymentMethods,
                                        },
                                        warnings: validStatus.warning,
                                    },
                                };
                            }
                        })
                        .finally(() => $rootScope.isLoading = false);

                };

                $scope.confirmWarning = function() {
                    $scope.validation = angular.copy(validation);
                    tripFactory.showCheckout($scope.temporaryTripId, tripDepartmentId, null, false);
                };

                $scope.cancelWarning = function() {
                    $scope.validation = angular.copy(validation);
                };
                $scope.cancelAlert = {
                    visible: false,
                    type: 'success',
                    msg: '',
                    show: function(isShow, type, msg) {
                        this.visible = isShow;
                        this.type = (type) ? type : this.type;
                        this.msg = (msg) ? msg : this.msg;
                    },
                };

                $scope.cancelTrip = function() {
                    if (isCancelTripBtnDisabled()) {
                        return;
                    }
                    if ($rootScope.readOnlyMode) {
                        $state.go('login');
                        return;
                    }

                    const tripStatus = $scope.tripDetails.Status;

                    vm.cancellation.cancellingWholeTrip = true;

                    if ([STATUS_QUOTE, STATUS_HELD].includes(tripStatus)) {
                        vm.cancellation.cancellationMsg = {
                            message: true,
                            quote: true,
                            isRefundable: tripUtils.isTripRefundable($scope.tripDetails),
                            railFlags: tripUtils.getRailMessageFlags($scope.tripDetails),
                        };
                    }

                    if ([STATUS_CONFIRMED, STATUS_ENROUTE].includes(tripStatus)) {
                        vm.cancellation.cancellationMsg = {
                            message: true,
                            confirmed: true,
                            isRefundable: tripUtils.isTripRefundable($scope.tripDetails),
                            nonRefundableItems: tripUtils.getTripNonRefundableItems($scope.tripDetails),
                            railFlags: tripUtils.getRailMessageFlags($scope.tripDetails),
                        };
                    }
                };

                $scope.adoptCancellation = function(tripItemCancellationForm) {
                    vm.cancellationForm.$setSubmitted();

                    if (vm.cancellationForm && vm.cancellationForm.$invalid) {
                        return;
                    }

                    if (!tripCancellationService.hasUserAnsweredOnAllQuestions(vm.cancellation)) {
                        tripCancellationService.scrollToTheLastSectionWithError();
                        return;
                    }

                    if (tripItemCancellationForm && tripItemCancellationForm.bookingComMessage) {
                        Object.assign(vm.cancellationForm, {bookingComMessage: tripItemCancellationForm.bookingComMessage});
                    }

                    vm.cancellation.cancellationMsg = {};
                    tripCancellationService
                        .cancelTrip(tripId, vm.cancellation, vm.cancellationForm)
                        .then(({data, wereSomeTicketsCollected}) => {
                            tripDetails.Status = STATUS_CANCELLED;
                            $scope.$broadcast(tripEvents.TRIP_DETAILS_UPDATE);

                            $scope.validation = angular.copy(validation);

                            let type = 'success';
                            let message = '';

                            function addMessage(value) {
                                message += l10nService.localize(value) + ' ';
                            }

                            if (data.AllCancellationsSuccessful) {
                                addMessage('This trip has been successfully cancelled!');
                            } else if (isAnyHotelUnconfirmed() || isAnyEuRailUnconfirmed()) {
                                $scope.tripDetails.Locked = true;
                                type = 'warning';
                                addMessage(`
                                    We are waiting for one or more supplier/s to confirm the below cancellation request/s.
                                    Those items which could be cancelled have been cancelled.
                                    The trip has now been locked while our Online Helpdesk monitor the request/s and they will contact you once they receive a response;
                                    please do not try to re-cancel the below options as they may have already been cancelled.
                                `);
                            } else {
                                type = 'warning';
                                addMessage(`
                                    Unfortunately there has been a technical issue cancelling this trip. 
                                    The items displayed were not cancelled.
                                    Please contact the Online helpdesk for assistance
                                `);
                            }

                            if (wereSomeTicketsCollected) {
                                addMessage(`
                                    To process tickets already collected from a kiosk, or received by Royal Mail, post them to: Refunds, The Trainline, PO Box 23972, Edinburgh, EH3 5DA. 
                                    Note that refunds cannot be processed until the tickets are received by Trainline and may take up to 8 weeks to be credited back to your account. 
                                    For tickets yet ‘uncollected’ from a kiosk, refunds will be automatically processed upon cancellation
                                `);
                            }

                            if (type && message) {
                                $scope.cancelAlert.show(true, type, message);
                                scrollService.scrollToElement('.cancellation-message');
                            }

                            function isAnyHotelUnconfirmed() {
                                return _.chain(data.CancelledHotels)
                                        .reduce((hotels, providerHotels) => hotels.concat(_.values(providerHotels)), [])
                                        .indexOf(CANCEL_ITEM_STATUSES.UNCONFIRMED)
                                        .value() !== -1;
                            }

                            function isAnyEuRailUnconfirmed() {
                                return _.chain(data.CancelledEuRails)
                                        .reduce((rails, providerRails) => rails.concat(_.values(providerRails)), [])
                                        .indexOf(CANCEL_ITEM_STATUSES.UNCONFIRMED)
                                        .value() !== -1;
                            }
                        }
                    );

                };

                $scope.rejectCancellation = function() {
                    vm.cancellationForm.$setPristine();
                    vm.cancellation.cancellationMsg = {};
                };

                $scope.rejectFlight = function() {
                    if ($rootScope.readOnlyMode) {
                        $state.go('login');
                        return null;
                    }
                    //todo: Implement Reject Flight Functionality
                };

                $scope.everyItemCannotBeCancelled = function() {
                    return tripFactory.everyItemCannotBeCancelled(tripDetails);
                };

                $scope.reviews = _.map(getReversedReviews(), createReviewInstance);
                $scope.lastReview = $scope.reviews[0];

                if ($scope.lastReview && $scope.lastReview.needToShowTripItems()) {
                    $scope.reviewComment.message = $scope.lastReview.getFirstUserReview().comment;
                }

                $scope.$on(tripEvents.TRIP_DETAILS_UPDATE, function() {
                    tripFactory.tripDetails(tripId)
                        .then((data) => {
                            $scope.tripDetails = data;
                            $scope.isTripCancelled = (data.Status === STATUS_CANCELLED);
                            $scope.cancelWarning();
                            $scope.isVisibleSendBlock = false;
                    });
                });
                $scope.$on(tripEvents.TRIP_SHOW_CHANGES_BLOCK, function(obj, arg) {
                    $scope.showChangesBlock = arg;
                });
                Object.assign($scope, {
                    showOnlyHistory,
                    clearOptionPreferences,
                    isTripConfirmed: isTripHoldOrQuote,
                    needToShowVerifyButton,
                    needToShowHistoryButton,
                    isTripPendingReview,
                    isTripReviewed,
                    dismissReview,
                    acceptReview,
                    getTripDestination,
                });

                vm.isBookAmendmentButtonDisabled = $scope.tripDetails.CanBeBookedStatus === TRIP_CAN_BE_BOOK_STATUSES.AUTOBOOKING_IN_PROCESS;
            }

            $scope.getTooltip = function() {
                if ($scope.tripDetails.CanBeBookedStatus === TRIP_CAN_BE_BOOK_STATUSES.AUTOBOOKING_IN_PROCESS) {
                    return tripFactory.getBookErrorTooltipContent(
                        $scope.tripDetails.CanBeBookedStatus,
                        userService.isUSRegion()
                    );
                }

                const {Status} = $scope.tripDetails;
                if ([STATUS_CONFIRMED, STATUS_CANCELLED].includes(Status)) {
                    return '';
                }

                let baseTooltip = l10nService.localize('This request cannot be processed '
                    + 'as it is too close to the departure time. ');
                baseTooltip += l10nService.localize('Please contact your reservation team during working hours, or if out '
                    + 'of hours please contact our 24 hour emergency team on ');

                const phoneNumber = userService.isUSRegion()
                    ? '+01 (888) 339 - 1502'
                    : '+44 (0) 20 7843 9602';

                return baseTooltip + phoneNumber;
            };

             function toggleReviewBlockForBooker() {
                if (isLockedCancelledOrConfirmed()) {
                    return;
                }

                $scope.toggleReviewBlock();
            }

            function clearOptionPreferences() {
                $scope.tripDetails.reviewModel = _.mapValues($scope.tripDetails.reviewModel, function() {
                    return {};
                });
            }

            function showOnlyHistory() {
                return needToShowHistoryButton();
            }

            function needToShowHistoryButton() {
                return (!isTripHoldOrQuote() || !currentStageAllowVerify())
                    && userAllowedVerifyTrip
                    && !!$scope.atLeastOneReviewWasSent;
            }

            function needToShowVerifyButton() {
                return isTripHoldOrQuote()
                    && currentStageAllowVerify()
                    && userAllowedVerifyTrip();
            }

            function userAllowedVerifyTrip() {
                return userService.isBooker() && !isCurrentUserTripApprover();
            }

            function isCurrentUserTripApprover() {
                return userService.isApprover() && $scope.tripDetails.IsAwaitingUserApproval;
            }

            function isTripHoldOrQuote() {
                return [STATUS_QUOTE, STATUS_HELD].includes($scope.tripDetails.Status);
            }

            function currentStageAllowVerify() {
                const {Locked, IsTimeLocked, CurrentStage} = $scope.tripDetails;
                return !Locked && !IsTimeLocked
                    && CurrentStage !== STAGE.PENDING_APPROVAL
                    && CurrentStage !== STAGE.APPROVED
                    && CurrentStage !== STAGE.DECLINED
                    && CurrentStage !== STAGE.DEADLINE_EXCEEDED
                    && CurrentStage !== STAGE.AMENDMENT_PENDING_APPROVAL
                    && CurrentStage !== STAGE.AMENDMENT_APPROVED
                    && CurrentStage !== STAGE.AMENDMENT_DECLINED
                    && CurrentStage !== STAGE.AMENDMENT_DEADLINE_EXCEEDED;
            }

            function isVisibleReviewBlockInitially() {
                return isVisibleVerifyBlock;
            }

            function isTripHasReviews() {
                return $scope.tripDetails.ReviewTripInfo
                    && $scope.tripDetails.ReviewTripInfo.FeedbackReviews
                    && $scope.tripDetails.ReviewTripInfo.FeedbackReviews.length;
            }

            function isTripPendingReview() {
                return $scope.tripDetails.ReviewStatus === TRIP_CONSTANTS.REVIEW_STATUSES.SENT
                    && isTripHasReviews() && currentStageAllowVerify();
            }

            function isTripReviewed() {
                return $scope.tripDetails.ReviewStatus === TRIP_CONSTANTS.REVIEW_STATUSES.REVIEWED
                    && isTripHasReviews() && currentStageAllowVerify();
            }

            function showAcceptDismiss() {
                return $scope.tripDetails.ReviewTripInfo
                    && $scope.tripDetails.ReviewTripInfo.CanBeChangesAccepted
                    && currentStageAllowVerify()
                    && userService.isBooker();
            }

            function acceptReview() {
                tripAPI.acceptReview($scope.tripDetails.Id, true).then(() => {
                    ktAlert.success(l10nService.localize('Trip Accepted'));
                    $scope.$broadcast(tripEvents.TRIP_DETAILS_UPDATE);
                });
            }

            function dismissReview() {
                tripAPI.acceptReview($scope.tripDetails.Id, false).then(() => {
                    ktAlert.success(l10nService.localize('Trip Dismissed'));
                    $scope.$broadcast(tripEvents.TRIP_DETAILS_UPDATE);
                });
            }

            function getTripDestination() {
                return tripUtils.getTripDestination($scope.tripDetails);
            }

            function getReversedReviews() {
                return $scope.tripDetails
                    && $scope.tripDetails.ReviewTripInfo
                    && $scope.tripDetails.ReviewTripInfo.FeedbackReviews
                    && [...$scope.tripDetails.ReviewTripInfo.FeedbackReviews].reverse()
                    || [];
            }

            function createReviewInstance(review) {
                return new ReviewConstructor(review);
            }

            function isRequestConfirmationButtonVisible() {
                return !$scope.tripDetails.IsOfflineTrip && [STATUS_CONFIRMED, STATUS_HELD].includes($scope.tripDetails.Status);
            }

            function isWarningPanelVisible() {
                const {validation} = $scope;
                return validation.messages.warnings.length
                    && !validation.messages.errors.length
                    && validation.messages.payment.isValid;
            }
    function initializeSelectedSeats() {
        const selectedSeats = tripTravellerAllocationService.prepareSeats($scope.tripDetails);
        $scope.seats.selectedSeats = tripTravellerAllocationService.addNonSelectedSeats(selectedSeats, $scope.tripDetails);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsController.js